<template>
  <div class="layout-bottom" @click="setMobile">
      <el-icon><el-icon-expand v-if="isMobile"/><el-icon-fold v-else /></el-icon>
  </div>
</template>

<script>
export default {
data() {
    return {

    }
  },
  methods:{
    setMobile(){
      this.$store.commit('setMobile', !this.isMobile)
    }
  },
  computed:{
    isMobile(){
      return this.$store.state.app.isMobile;
    },
  }
}
</script>

<style lang="scss" scoped>
.layout-bottom {
  height:50px;
  border-top: 1px solid #ebeef5;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--system-logo-background);
  i {
    font-size: 16px;
  }
  &:hover{
    color: var(--system-primary-text-color);
  }
}
</style>